import { render } from "./IngredientCheckerSubscription.vue?vue&type=template&id=353523d0&scoped=true"
import script from "./IngredientCheckerSubscription.vue?vue&type=script&lang=js"
export * from "./IngredientCheckerSubscription.vue?vue&type=script&lang=js"

import "./IngredientCheckerSubscription.vue?vue&type=style&index=0&id=353523d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353523d0"]])

export default __exports__